import React from 'react';
import { CTABand } from '../../components/CTABand';
export function AboutFinalCTA() {
  return <CTABand headline="Train With the Best" copy="Experience our coaching firsthand. Claim your free week and meet the team." data-id="element-459" />;
}